module.exports = __webpack_public_path__ + "static/img/07.f93427da.jpg";